// 绩效考核 通知公告路由  分支1.4.0
export default [
  {
    path: '/appraise/noticeManage',
    name: 'noticeManage',
    component: () => import('../../pages/appraise/noticeManage/index.vue'),
    meta: {
      title: '通知公告管理'
    }
  },
  {
    path: '/appraise/addNotice',
    name: 'addNotice',
    component: () => import('../../pages/appraise/noticeManage/addNotice.vue'),
    meta: {
      title: '发布公告'
    }
  },
  // 通知公告详情
  {
    path: '/appraise/noticeDetail',
    name: 'addNotice',
    component: () => import('../../pages/appraise/noticeManage/noticeDetail.vue'),
    meta: {
      title: '通知公告'
    }
  },
  {
    path: '/appraise/announcement',
    name: 'addNotice',
    component: () => import('../../pages/appraise/noticeManage/announcement.vue'),
    meta: {
      title: '通知公告'
    }
  },
  // 任务管理相关路由
  {
    path: '/appraise/taskManage',
    name: 'taskManage',
    component: () => import('../../pages/appraise/taskManage/index.vue'),
    meta: {
      title: '任务管理'
    }
  },
  // 投诉数据管理
  {
    path: '/appraise/complaintManage',
    name: 'compaintManage',
    component: () => import('../../pages/appraise/complaintManage/index.vue'),
    meta: {
      title: '投诉数据管理'
    }
  },
  // 涉旅安全事故发生情况路由
  {
    path: '/appraise/travelAccident',
    name: 'travelAccident',
    component: () => import('../../pages/appraise/travelAccident/deductList.vue'),
    meta: {
      title: '扣分列表'
    }
  },
  {
    path: '/appraise/deductDetail',
    name: 'deductDetail',
    component: () => import('../../pages/appraise/travelAccident/deductDetail.vue'),
    meta: {
      title: '扣分详情'
    }
  },
  // 新增情况
  {
    path: '/appraise/addSituation',
    name: 'addSituation',
    component: () => import('../../pages/appraise/travelAccident/addSituation.vue'),
    meta: {
      title: '新增情况'
    }
  },
  // 新增情况-审核
  {
    path: '/appraise/checkSituation',
    name: 'checkSituation',
    component: () => import('../../pages/appraise/travelAccident/checkSituation.vue'),
    meta: {
      title: '审核'
    }
  },
  // 受到通报批评模块
  {
    path: '/appraise/notificationList',
    name: 'notificationList',
    component: () => import('../../pages/appraise/notification/notificationList.vue'),
    meta: {
      title: '扣分列表'
    }
  },
  // 受到通报批评模块 - 详情
  {
    path: '/appraise/notificationDetail',
    name: 'notificationDetail',
    component: () => import('../../pages/appraise/notification/notificationDetail.vue'),
    meta: {
      title: '扣分列表'
    }
  },
  // 新增情况
  {
    path: '/appraise/notificationAdd',
    name: 'notification',
    component: () => import('../../pages/appraise/notification/addSituation.vue'),
    meta: {
      title: '新增情况'
    }
  },
  // 通报批评扣分详情
  {
    path: '/appraise/deductDetailNotifi',
    name: 'deductDetailNotifi',
    component: () => import('../../pages/appraise/notification/deductDetail.vue'),
    meta: {
      title: '扣分详情'
    }
  },
  // 批评通报-审核
  {
    path: '/appraise/checkSituationNotifi',
    name: 'checkSituationNotifi',
    component: () => import('../../pages/appraise/notification/checkSituation.vue'),
    meta: {
      title: '审核'
    }
  },
  // 舆情模块 路由
  // 舆情 扣分列表
  {
    path: '/appraise/negativeList',
    name: 'negativeList',
    component: () => import('../../pages/appraise/travelNegative/negativeList.vue'),
    meta: {
      title: '扣分列表'
    }
  },
  // 舆情-扣分详情
  {
    path: '/appraise/deductDetailNegative',
    name: 'deductDetailNegative',
    component: () => import('../../pages/appraise/travelNegative/deductDetail.vue'),
    meta: {
      title: '扣分详情'
    }
  },
  // 舆情-审核
  {
    path: '/appraise/checkNegative',
    name: 'checkNegative',
    component: () => import('../../pages/appraise/travelNegative/checkNegative.vue'),
    meta: {
      title: '审核'
    }
  },
  // 舆情-新增情况-新增概况 step1
  {
    path: '/appraise/addNegative',
    name: 'addNegative',
    component: () => import('../../pages/appraise/travelNegative/addNegative.vue'),
    meta: {
      title: '新增情况'
    }
  },
  // 舆情-新增情况-新增概况 step2
  {
    path: '/appraise/addNegativeDesc',
    name: 'addNegativeDesc',
    component: () => import('../../pages/appraise/travelNegative/addNegativeDesc.vue'),
    meta: {
      title: '新增情况'
    }
  },
  // 舆情-新增情况-新增概况 step3
  {
    path: '/appraise/addNegativeCitis',
    name: 'addNegativeCitis',
    component: () => import('../../pages/appraise/travelNegative/addNegativeCitis.vue'),
    meta: {
      title: '新增情况'
    }
  },
  // 涉旅企业诚信评价进展情况 路由
  // 诚信 扣分列表
  {
    path: '/appraise/creditList',
    name: 'creditList',
    component: () => import('../../pages/appraise/creditEvaluation/creditList.vue'),
    meta: {
      title: '扣分列表'
    }
  },
  {
    path: '/appraise/addCredit',
    name: 'addCredit',
    component: () => import('../../pages/appraise/creditEvaluation/addCredit.vue'),
    meta: {
      title: '新增情况'
    }
  },
  // 诚信-扣分详情
  {
    path: '/appraise/creditDetail',
    name: 'creditDetail',
    component: () => import('../../pages/appraise/creditEvaluation/creditDetail.vue'),
    meta: {
      title: '扣分详情'
    }
  },
  // 诚信-审核
  {
    path: '/appraise/checkCredit',
    name: 'checkCredit',
    component: () => import('../../pages/appraise/creditEvaluation/checkCredit.vue'),
    meta: {
      title: '审核'
    }
  },
  // 空白页面，处理消息跳转的
  {
    path: '/appraise/assessMsgHandle',
    name: 'assessMsgHandle',
    component: () => import('../../pages/appraise/noticeManage/assessMsgHandle.vue'),
    meta: {
      title: '考核消息跳转处理中心'
    }
  },
]
